import React, { useState, useEffect } from "react";

import SideMenu from "./SideMenu";

import type { SideMenuElement } from "../types.d";

type SideMenuAnchorProp = {
  data: SideMenuElement[] | SideMenuElement;
};

function SideMenuWithAnchorLinks(props: SideMenuAnchorProp) {
  const { data } = props;
  const [isSelected, setIsSelected] = useState<string | undefined>();

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll<HTMLHeadingElement>("h2[id]");
      let selectedId: string | null = null;

      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();

        // Check if the element is in the desired range of the viewport (e.g., between 0 and 200px from the top)
        if (rect.top <= 200 && rect.top >= 0) {
          if (!selectedId || rect.top < document.getElementById(selectedId)!.getBoundingClientRect().top) {
            selectedId = element.id;
          }
        }
      });

      if (selectedId) {
        setIsSelected(`#${selectedId}`);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Only runs once on mount and unmount

  const handleClick = (key: string) => {
    setIsSelected(key);
    const element = document.querySelector(key);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <SideMenu
      data={data}
      activeKey={isSelected}
      onItemClick={(item, e) => {
        e.preventDefault();
        if (item.link) handleClick(item.link);
      }}
      linkProps={{ "data-skip-to-content": "true" }}
      useHierarchicalNumbering={false}
    />
  );
}

export default function(props: SideMenuAnchorProp) {
  return <SideMenuWithAnchorLinks {...props} />;
}
